import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import CrudContext from "../../context/crudContext";
import FormContext from "../../context/formContext";
import styles from "../../styles/form.module.css";

export default function CrudForm() {
  const { createData, updateData, dataToEdit, setDataToEdit } =
    useContext(CrudContext);

  const { form, setForm, initialForm } = useContext(FormContext);

  useEffect(() => {
    if (dataToEdit) {
      setForm(dataToEdit);
    } else {
      setForm(initialForm);
    }
  }, [dataToEdit]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  let navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.pro_id === null) {
      createData(form);
      setForm(initialForm);
      setDataToEdit(null);
      swal({
        title: "Producto Agregado!",
        icon: "success",
      });
    } else {
      updateData(form);
      swal({
        title: "Producto Editado!",
        icon: "success",
      });
      navigate("/administrador", { replace: true });
    }
  };

  return (
    <>
      <section className={styles.sectionForm}>
        <div className={styles.formContainer}>
          <h2 className={styles.formTitle}>
            {dataToEdit ? "Editar producto" : "Agregar producto"}
          </h2>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div>
              <p>Ingresa el nombre</p>
              <input
                type="text"
                name="pro_name"
                value={form.pro_name}
                onChange={handleChange}
              />
            </div>

            <div>
              <p>Ingresa la categoría</p>
              <input
                type="text"
                name="pro_category"
                value={form.pro_category}
                onChange={handleChange}
              />
            </div>

            <div>
              <p>Ingresa el proveedor</p>
              <input
                type="text"
                name="pro_provider"
                value={form.pro_provider}
                onChange={handleChange}
              />
            </div>

            <div>
              <p>Ingresa número de existencias</p>
              <input
                type="text"
                name="pro_existences"
                placeholder="Categoria"
                value={form.pro_existences}
                onChange={handleChange}
              />
            </div>

            <div>
              <p>Ingresa la fecha</p>
              <input
                type="datetime-local"
                name="pro_date"
                value={form.pro_date}
                onChange={handleChange}
              />
            </div>

            <div>
              <p>Ingresa la descripción</p>
              <input
                type="text"
                name="pro_description"
                value={form.pro_description}
                onChange={handleChange}
              />
            </div>

            <input
              type="submit"
              value={dataToEdit ? "Editar producto" : "Guardar producto"}
              className={styles.btnSubmit}
            />
          </form>
        </div>
      </section>
    </>
  );
}
